<template>
    <div @mouseover="activate"
         @mouseout="deactivate"
         class="relative cursor-pointer relative z-10">
        <slot name="heading"></slot>

        <div v-show="active"
             class="bg-gray-400 p-6 text-black absolute rounded rounded-tr-30 right-0 top-0 w-48"
        >
            <h4 class="mb-4 capitalize">
                <slot name="username"></slot>
            </h4>

            <ul class="list-reset">
                <slot name="links"></slot>
            </ul>
        </div>
    </div>
</template>

<script>
    import activation from '../mixins/activation';

    export default {
        mixins: [activation]
    };
</script>